export const generateSignatureTemplate = ({ name, position, phone }) => `
  <table style="caption-side: bottom; border-collapse: collapse; font-family: Inter, sans-serif; font-variant-ligatures: normal; orphans: 2; widows: 2; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;">
    <tr>
      <td>
        <a href="https://www.transferbank.com.br" target="_blank">
          <img src="https://prod-tb-public-files.s3.us-east-1.amazonaws.com/email/template/transferbank_simbolo.gif" style="width: 110px;">
        </a>
      </td>
      <td>
        <a href="https://www.transferbank.com.br" target="_blank">
          <img src="https://prod-tb-public-files.s3.us-east-1.amazonaws.com/email/template/barra.png" style="width: 1.5px; height: 130px; margin-left: 20px; margin-right: 10px">
        </a>
      </td>
      <td style="width: 270px;">
        <strong style="text-align: left; font-size: 16px; display: block; color: rgb(0, 0, 0)">
          ${name || 'Seu Nome'}
        </strong>
        <span style="text-align: left; margin-bottom: 1px; margin-top:-2px; font-size: 12px; display: block; color: rgb(0, 0, 0)">
          ${position || 'Seu Cargo'}
        </span>
        <a href="https://www.transferbank.com.br" target="_blank">
          <img src="https://prod-tb-public-files.s3.us-east-1.amazonaws.com/email/template/logo_email.png" style="width: 110px;">
        </a>
        <span style="text-align: left; font-size: 11px; display: block; color: rgb(0, 0, 0)">
          ${phone || '+55 (00) 00000-0000'}
        </span>
        <span style="text-align: left; font-size: 11px; display: block; margin-bottom: 6px; color: #0AA092 !important; text-decoration: none; -webkit-text-fill-color: #0AA092 !important; -webkit-text-stroke: 0px #0AA092 !important;">
         <u style="color: #0AA092 !important; text-decoration: none; -webkit-text-fill-color: #0AA092 !important; -webkit-text-stroke: 0px #0AA092 !important;">www.transferbank.com.br</u>
        </span>
        <span>
          <a href="https://www.linkedin.com/company/transferbank/" target="_blank" style="text-decoration: none;">
            <img src="https://prod-tb-public-files.s3.us-east-1.amazonaws.com/email/template/linkedin.png" style="width: 22px;">
          </a>
        </span>
        <span>
          <a href="https://www.instagram.com/transferbank_/" target="_blank" style="text-decoration: none;">
            <img src="https://prod-tb-public-files.s3.us-east-1.amazonaws.com/email/template/instagram.png" style="width: 22px;"> 
          </a>
        </span>
        <span>
          <a href="https://api.whatsapp.com/send/?phone=15614059768&text=Ol%C3%A1%2C+poderia+me+auxiliar+com+minhas+remessas+internacionais%3F&type=phone_number&app_absent=0" target="_blank" style="text-decoration: none;">
            <img src="https://prod-tb-public-files.s3.us-east-1.amazonaws.com/email/template/whatsapp.png" style="width: 22px;"> 
          </a>
        </span>
      </td>
    </tr>
  </table>
`
